import { createPreflight } from '@xstyled/system'
import { createGlobalStyle } from 'styled-components'

export const Preflight = createPreflight({ createGlobalStyle })
